/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CreateProjectRequest model module.
 * @module model/CreateProjectRequest
 * @version 2.8.0
 */
class CreateProjectRequest {
    /**
     * Constructs a new <code>CreateProjectRequest</code>.
     * @alias module:model/CreateProjectRequest
     * @param name {String} 
     */
    constructor(name) { 
        
        CreateProjectRequest.initialize(this, name);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name) { 
        obj['name'] = name;
    }

    /**
     * Constructs a <code>CreateProjectRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CreateProjectRequest} obj Optional instance to populate.
     * @return {module:model/CreateProjectRequest} The populated <code>CreateProjectRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateProjectRequest();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('collections')) {
                obj['collections'] = ApiClient.convertToType(data['collections'], ['String']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
CreateProjectRequest.prototype['name'] = undefined;

/**
 * @member {Array.<String>} collections
 */
CreateProjectRequest.prototype['collections'] = undefined;






export default CreateProjectRequest;

